import { observable, action } from "mobx";
import { RootStore } from "@state/stores/types";

class PageStore {
	@observable private _headerType:
		| "main-page"
		| "sub-page"
		| "minimal-page"
		| "main-page-with-search"
		| "sub-page-with-search"
		| "casino-main-page-with-search"
		| "casino-sub-page-with-search" = "main-page";
	@observable private _backButton: (() => void) | null = null;
	@observable private _title: string = "";

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	get headerType() {
		return this._headerType;
	}

	get backButton() {
		return this._backButton;
	}

	get title() {
		return this._title;
	}

	@action.bound
	setMainPageSearchHeader() {
		this.rootStore.searchStore.onReset();
		this.rootStore.searchStore.setIsSearchOpen(false);
		this._headerType = "main-page-with-search";
	}

	@action.bound
	setSubPageSearchHeader(params: { title: string }) {
		this._headerType = "sub-page-with-search";
		this._title = params?.title || "";
	}

	@action.bound
	setMainPageHeader() {
		this._headerType = "main-page";
	}

	@action.bound
	setSubPageHeader(params?: { backButton?: () => void; title?: string }) {
		this._headerType = "sub-page";
		this._backButton = params?.backButton || (() => history.back());
		this._title = params?.title || "";
	}

	@action.bound
	setMinimalPageHeader() {
		this._headerType = "minimal-page";
	}

	@action.bound
	setCasinoMainPageSearchHeader() {
		this._headerType = "casino-main-page-with-search";
	}

	@action.bound
	setCasinoSubPageSearchHeader(params: {
		title: string;
		backButton?: VoidFunction;
	}) {
		this._headerType = "casino-sub-page-with-search";
		this._title = params?.title || "";
		this._backButton = params?.backButton || (() => history.back());
	}
}

export default PageStore;
